"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Check;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _cssConstants = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _GenericStore = require("../store/GenericStore");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _targetCss$colors, _targetCss$colors2;

var StyledCheckbox = (0, _withStyles["default"])({
  root: {
    '&$checked': {
      color: (_targetCss$colors = _cssConstants["default"].colors) === null || _targetCss$colors === void 0 ? void 0 : _targetCss$colors.buttonBackground
    },
    color: (_targetCss$colors2 = _cssConstants["default"].colors) === null || _targetCss$colors2 === void 0 ? void 0 : _targetCss$colors2.buttonBackground
  }
})(_Checkbox["default"]);

function Check(props) {
  var parentPath = props.parentPath;

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath + '/value', false),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      checked = _useDataStore2[0],
      setChecked = _useDataStore2[1];

  var handleChange = function handleChange(event) {
    setChecked(event.target.checked);
  };

  return /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    checked: checked,
    onChange: handleChange,
    color: "primary",
    inputProps: {
      'aria-label': 'secondary checkbox'
    }
  });
}